import React from "react";
import styled from "styled-components";

import * as Button from "~/Button";
import * as Layout from "~/Layout";
import { Timeline } from "~/Timeline";

export function Controller({
  onLeft,
  onLeftMax,
  onRight,
  onRightMax,
  onZoomIn,
  onZoomOut,
  onZoomReset,
}: Timeline.Scroll.Events) {
  return (
    <Controller.Container>
      <Button.Component title="«" onClick={onLeftMax} />
      <Button.Component title="‹" onClick={onLeft} />
      <Button.Component title="›" onClick={onRight} />
      <Button.Component title="»" onClick={onRightMax} />
      <Button.Component title="+" onClick={onZoomIn} />
      <Button.Component title="-" onClick={onZoomOut} />
      <span>
        <Button.Component title="Reset" onClick={onZoomReset} />
      </span>
    </Controller.Container>
  );
}

export namespace Controller {
  export const Container = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;

    & > * {
      margin-left: ${() => Layout.Inline.padding()};
    }

    & > button {
      width: 2.7em;
      & > span {
        transform: scale(2) translateY(-3%);
      }
    }
  `;
}
